





































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import Util from '@/lib/util';
import hzmailbox from '@/store/entities/sm/hzmailbox';
import elementResizeDetector from "element-resize-detector";
@Component({
  components: {  }
})
export default class HzMailReads extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:String,default:'0'}) messageid:string;
    @Prop({type:String,default:''}) pid:string;
    @Prop({type:String,default:''}) titlename:string;
    @Prop({type:Boolean,default:false}) isletter:boolean;
    title:string ="邮件查看";
    loadingInstance:boolean=false;
    downloading:boolean=false;
    ocrloading:boolean=false;
    currMail:hzmailbox=new hzmailbox();
    visibleChange(value) {
      if (!value) {
        (this.$refs["mailRef"] as any).resetFields();
        this.$emit('input',false);
      }
      else{
        this.getdata();
      }
    }
    downAttachment(attachment) {
      Util.downBase64File(attachment.base64Content,attachment.fileName);
    }
    cancel(){
      (this.$refs["mailRef"] as any).resetFields();
      this.$emit('input',false);
    }
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    }
    async getdata(){
        var id=this.messageid;
        var pid=this.pid;
        this.loadingInstance=true;
        var reponse=await this.$store.dispatch({
            type:'hzmail/GetItem',
            data:{Id:id,ProjectId:pid}
        });
        this.title="邮件查看"+this.titlename;
        if(reponse.success&&reponse.result.length>0){
            this.currMail=Util.extend(true,{},reponse.result[0]);
            this.loadingInstance=false;
        }
        else{
            this.loadingInstance=false;
        }
    }
    async DownMail(){
        this.downloading=true;
        await this.$store.dispatch({
            type:'hzmail/downMail',
            data:{id:this.messageid,projectid:this.pid,filename:this.titlename}
        });
        this.downloading=false;
    }
    async OcrMail(){
        this.ocrloading=true;
        var keywords="";
        var reponse=await this.$store.dispatch({
            type:'hzmail/OcrMail',
            data:{id:this.messageid,value:keywords}
        });
        this.ocrloading=false;
        if(reponse.success&&reponse.result.length>0){
            if(reponse.result[0].letterId == '0'){
                this.$prompt('', '请输入被审计单位名称和函证编号并用#分隔', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                inputType: 'textarea',
                inputPattern: /^(?!(\s+$))/,
                inputPlaceholder:'被审计单位名称#函证编号',
                inputValidator: (value) => {
                    if (!value || value.trim() === '') {
                    return '关键信息不能为空';
                    }
                    return true;
                },
                inputErrorMessage: '关键信息不能为空'
                }).then( async (value:any) => {
                    keywords=value.value;
                    reponse=await this.$store.dispatch({
                        type:'hzmail/OcrMail',
                        data:{id:this.messageid,keyword:keywords}
                    });
                    if(reponse.success&&reponse.result.length>0){
                       if(reponse.result[0].letterId == '0'){
                          await this.$alert("未能根据输入信息识别到函证.","提示");
                       }
                       else{
                          await this.$Modal.info({
                                title: this.L('提示'),
                                content: "识别成功",
                                onOk: () => {
                                    (this.$refs["mailRef"] as any).resetFields();
                                    this.$emit('input',false);
                                    this.$emit('save-success');
                                }
                            });
                       }
                    }
                }).catch(() => { 

                });
            }
            else
            {
               await this.$Modal.info({
                    title: this.L('提示'),
                    content: "识别成功",
                    onOk: () => {
                        (this.$refs["mailRef"] as any).resetFields();
                        this.$emit('input',false);
                        this.$emit('save-success');
                    }
                });
            }
        }
        else{
            await this.$alert(reponse.error,"提示");
        }
    }
    async mounted(){
       const that = this;
       var wh=window.innerHeight-188
       var erd = elementResizeDetector();
       erd.listenTo(document.querySelectorAll("#mailread .ivu-modal-content"), (element) => {              
        that.$nextTick(() => { 
            let ivumodal=$(".modal-mail > div.ivu-modal");
            if(ivumodal){
              ivumodal.css('top','45px');//100px
            }
            let modalbody=$(".modal-mail > div.ivu-modal > div.ivu-modal-content > div.ivu-modal-body");
            if(modalbody){
               modalbody.css('max-height',wh+'px');//480px
            }
        });
      });
      
    }
}
